import Uuid from '../model/Uuid';

const baseUrl = '/legislativne-procesy/SK';

export default {
  loading: { to: '/loading' },
  home: { name: 'Domov', to: '/' },
  procesy: {
    list: {
      to: '/elegislativa/legislativne-procesy',
      name: 'Legislatívne procesy',
    },
    detail: {
      withParams: (type: string, year: number, index: number):
        string => `/elegislativa${baseUrl}/${type}/${year}/${index}`,
      name: (type = '', year = '', index = ''): string => `${type}/${year}/${index}`,
    },
  },
  predbeznaInformacia: {
    list: {
      to: '/elegislativa/predbezne-informacie',
      name: 'Predbežné informácie',
    },
  },
  unauthorized: '/unauthorized',
  process: (siteUrl: string, type: string, year: number, index: number):
    string => `${siteUrl}${baseUrl}/${type}/${year}/${index}`,
  vzneseneInMpk: (siteUrl: string, staticUrl: string, fileName: string):
    string => `${siteUrl}/${staticUrl}/${fileName}`,
  pripomienky: {
    index: (type: string, year: number, index: number):
      string => `${baseUrl}/${type}/${year}/${index}/pripomienky`,
    list: {
      raw: `${baseUrl}/:type/:year/:index/pripomienky/zobraz`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/pripomienky/zobraz`,
      name: 'Pripomienky',
    },
    add: {
      raw: `${baseUrl}/:type/:year/:index/pripomienky/pridaj`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/pripomienky/pridaj`,
      name: 'Nová pripomienka',
    },
    edit: {
      raw: `${baseUrl}/:type/:year/:index/pripomienky/:uuid/uprav`,
      withParams: (type: string, year: number, index: number, uuid: string):
        string => `${baseUrl}/${type}/${year}/${index}/pripomienky/${uuid}/uprav`,
      name: 'Úprava pripomienky',
    },
    detail: {
      raw: `${baseUrl}/:type/:year/:index/pripomienky/:uuid/detail`,
      withParams: (
        type: string,
        year: number,
        index: number,
        uuid: string,
      ): string => `${baseUrl}/${type}/${year}/${index}/pripomienky/${uuid}/detail`,
      name: 'Detail pripomienky',
    },
    evaluate: {
      raw: `${baseUrl}/:type/:year/:index/pripomienky/:uuid/vyhodnotit`,
      withParams: (type: string, year: number, index: number, uuid: string):
        string => `${baseUrl}/${type}/${year}/${index}/pripomienky/${uuid}/vyhodnotit`,
      name: 'Vyhodnotenie pripomienky',
    },
    hromadneVyhodnotit: {
      raw: `${baseUrl}/:type/:year/:index/pripomienky/hromadne-vyhodnotit`,
      withParams: (type: string, year: number, index: number, uuids: Uuid[]):
        string => `${baseUrl}/${type}/${year}/${index}/pripomienky/hromadne-vyhodnotit?pripomienkyUuids=${uuids}`,
      name: 'Pripomienky',
    },
  },
  hromadnePripomienky: {
    index: (type: string, year: number, index: number):
      string => `${baseUrl}/${type}/${year}/${index}/hromadne-pripomienky`,
    list: {
      raw: `${baseUrl}/:type/:year/:index/hromadne-pripomienky/zobraz`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/hromadne-pripomienky/zobraz`,
      name: 'Hromadné pripomienky',
    },
    detail: {
      raw: `${baseUrl}/:type/:year/:index/hromadne-pripomienky/:uuid/detail`,
      withParams: (
        type: string,
        year: number,
        index: number,
        uuid: string,
      ): string => `${baseUrl}/${type}/${year}/${index}/hromadne-pripomienky/${uuid}/detail`,
      name: 'Detail pripomienky',
    },
    add: {
      raw: `${baseUrl}/:type/:year/:index/hromadne-pripomienky/pridaj`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/hromadne-pripomienky/pridaj`,
      name: 'Nová hromadná pripomienka',
    },
    evaluate: {
      raw: `${baseUrl}/:type/:year/:index/hromadne-pripomienky/:uuid/vyhodnotit`,
      withParams: (type: string, year: number, index: number, uuid: string):
        string => `${baseUrl}/${type}/${year}/${index}/hromadne-pripomienky/${uuid}/vyhodnotit`,
      name: 'Vyhodnotenie hromadnej pripomienky',
    },
    hromadneVyhodnotit: {
      raw: `${baseUrl}/:type/:year/:index/hromadne-pripomienky/hromadne-vyhodnotit`,
      withParams: (type: string, year: number, index: number, uuids: Uuid[]):
        string => `${baseUrl}/${type}/${year}/${index}/hromadne-pripomienky/hromadne-vyhodnotit`
        + `?pripomienkyUuids=${uuids}`,
      name: 'Pripomienky',
    },
  },
  export: {
    podporovatelia: {
      withParams: (
        type: string,
        year: number,
        index: number,
        uuid: string,
      ): string => `/external/evidencna-aplikacia/legislativne-materialy/${type}/${year}/${index}`
        + `/reporty/podporovatelia-hromadnej-pripomienky?pripomienkaUuid=${uuid}`,
    },
    pripomienkyOrg: {
      withParams: (
        type: string,
        year: number,
        index: number,
        organizaciaUuid: Uuid,
      ): string => `/external/evidencna-aplikacia/legislativne-materialy/${type}/${year}/${index}`
        + `/reporty/pripomienky-organizacie?organizaciaUuid=${organizaciaUuid}`,
    },
    pripomienkyPredkladatela: {
      withParams: (
        materialUuid: Uuid,
      ): string => `/external/evidencna-aplikacia/legislativne-materialy/${materialUuid}`
        + '/reporty/pripomienky',
    },
    vlastnyMaterial: {
      withParams: (
        uuid: Uuid,
        sprievodnyDokumentKod: string,
      ): string => `/external/evidencna-aplikacia/legislativne-materialy/${uuid}/sprievodne-dokumenty/`
        + `${sprievodnyDokumentKod}/download`,
    },
  },
  sendPripomienky: {
    raw: `${baseUrl}/:type/:year/:index/pripomienky/odoslat-pripomienky`,
    withParams: (type: string, year: number, index: number):
      string => `${baseUrl}/${type}/${year}/${index}/pripomienky/odoslat-pripomienky`,
    name: 'Odoslanie pripomienok',
  },
  admin: {
    addSubjektBezPripomienok: {
      raw: `${baseUrl}/:type/:year/:index/pripomienky/admin/odoslat-bez-pripomienok`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/pripomienky/admin/odoslat-bez-pripomienok`,
      name: 'Nový subjekt bez pripomienok',
    },
    pripomienky: {
      add: {
        raw: `${baseUrl}/:type/:year/:index/pripomienky/pridaj/admin`,
        withParams: (type: string, year: number, index: number):
          string => `${baseUrl}/${type}/${year}/${index}/pripomienky/pridaj/admin`,
        name: 'Nová pripomienka',
      },
      edit: {
        raw: `${baseUrl}/:type/:year/:index/pripomienky/:uuid/uprav/admin`,
        withParams: (type: string, year: number, index: number, uuid: string):
          string => `${baseUrl}/${type}/${year}/${index}/pripomienky/${uuid}/uprav/admin`,
        name: 'Úprava pripomienky',
      },
    },
    hromadnePripomienky: {
      add: {
        raw: `${baseUrl}/:type/:year/:index/hromadne-pripomienky/pridaj/admin`,
        withParams: (type: string, year: number, index: number):
          string => `${baseUrl}/${type}/${year}/${index}/hromadne-pripomienky/pridaj/admin`,
        name: 'Nová hromadná pripomienka',
      },
      edit: {
        raw: `${baseUrl}/:type/:year/:index/hromadne-pripomienky/:uuid/uprav/admin`,
        withParams: (type: string, year: number, index: number, uuid: string):
          string => `${baseUrl}/${type}/${year}/${index}/hromadne-pripomienky/${uuid}/uprav/admin`,
        name: 'Úprava pripomienky',
      },
    },
  },
};
